import CloseModalButton from "~/components/CloseModalButton";

function CookieModal() {
  return (
    <div
      className="hidden font-['Poppins',sans-serif] w-full h-auto bg-white my-0 mx-auto fixed bottom-0 left-0 right-0 z-50 justify-center items-center p-[22px]"
      style={{ boxShadow: "0px -3px 6px rgba(0, 0, 0, 0.1)" }}
      id="cookie-modal"
    >
      <div className="flex flex-col items-center justify-center md:flex-row">
        <div className="max-w-[762px] w-full md:mr-18">
          <p className="m-0 text-[#707070] text-[15px] leading-[22px] tracking-normal text-center md:text-left">
            Utilizamos dados estatísticos de visitas para melhorar sua
            experiência de navegação e personalizar nosso conteúdo e anúncios.
            Ao continuar navegando, você concorda com o nosso{" "}
            <strong>
              <a
                className="text-[#333333] no-underline"
                href="/institucional/aviso-de-privacidade"
                target="_blank"
              >
                aviso de privacidade
              </a>
              .
            </strong>
          </p>
        </div>
        <div className="flex justify-center items-center mt-5 md:mr-13 md:mt-0">
          <CloseModalButton />
        </div>
      </div>
    </div>
  );
}

export default CookieModal;
